import { ContainerDict } from "./container-dict.type";
import { ContainerKey } from "./container-key.type";
import { ContainerName } from "./container-name.type.const";

export const container: ContainerDict = {
  c20dc: "20DC",
  c40dc: "40DC",
  c40hc: "40HC",
  c45hc: "45HC",
  c20nor: "20NOR",
  c40nor: "40NOR",
  c20reef: "20REEF",
  c40hreef: "40HREEF",
  c45hreef: "45HREEF",
  c45plwd: "45PLWD",
  c20ot: "20OT",
  c40ot: "40OT",
  c20fr: "20FR",
  c40fr: "40FR",
  c20tank: "20TANK",
  c40tank: "40TANK",
};

export const containerKeys = <ContainerKey[]>Object.keys(container);
export const containerNames = <ContainerName[]>(
  Object.keys(container).map((key) => container[key])
);
